var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 45.52C21.0401 45.52 18.0601 44.4 15.7401 42.18C9.84011 36.5 3.32011 27.44 5.78011 16.66C8.00011 6.88 16.5401 2.5 24.0001 2.5C24.0001 2.5 24.0001 2.5 24.0201 2.5C31.4801 2.5 40.0201 6.88 42.2401 16.68C44.6801 27.46 38.1601 36.5 32.2601 42.18C29.9401 44.4 26.9601 45.52 24.0001 45.52ZM24.0001 5.5C18.1801 5.5 10.7001 8.6 8.72011 17.32C6.56011 26.74 12.4801 34.86 17.8401 40C21.3001 43.34 26.7201 43.34 30.1801 40C35.5201 34.86 41.4401 26.74 39.3201 17.32C37.3201 8.6 29.8201 5.5 24.0001 5.5Z",
    fill: "#080808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4999 27.4999C21.1199 27.4999 20.7399 27.3599 20.4399 27.0599L17.4399 24.0599C16.8599 23.4799 16.8599 22.5199 17.4399 21.9399C18.0199 21.3599 18.9799 21.3599 19.5599 21.9399L21.4999 23.8799L28.4399 16.9399C29.0199 16.3599 29.9799 16.3599 30.5599 16.9399C31.1399 17.5199 31.1399 18.4799 30.5599 19.0599L22.5599 27.0599C22.2599 27.3599 21.8799 27.4999 21.4999 27.4999Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTick);
export default __webpack_public_path__ + "static/media/location-tick.12561244608a648876cb3960b0108e96.svg";
export { ForwardRef as ReactComponent };